module.exports = __webpack_public_path__ + "static/media/CCTP - Health and Fitness Module (v2) -ENG.64bb9fd4.pptx";